<template>
  <button type="button"
          class="float-right mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-uknar-primary text-base font-medium text-white hover:bg-uknar-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary sm:mt-0 sm:text-sm"
          >

          <span class="w-full flex" v-if="loading">
            <svg class="animate-spin h-5 w-5 mr-3 ..." viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            {{buttonlabelloading}}
          </span>
    <span v-else>{{buttonlabel}}</span>
  </button>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false
    },
    buttonlabel: {
      type: String
    },
    buttonlabelloading: {
      type: String
    }
  },
}
</script>
